import React from 'react'
import { Route } from 'react-router-dom'
import Header from './../Layout/Header'
import { OfflineNotice } from '../OfflineNetwork'

const CustomRoute = props => {
   return (
    <>
      <OfflineNotice/>
      <Header {...props} />
      <Route {...props} />
    </>
  )
}

export default CustomRoute
